/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import { SegmentFormFragmentDoc } from '../../features/segment/components/SegmentForm/SegmentForm.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type ChatRoomStatus =
  /** 要対応(OA向けに作ったものだが、一般にも使えるようなenumにする) */
  | 'ActionRequired'
  /** 面談済み・対応中 */
  | 'Appointed'
  /** 対応不要 */
  | 'Archived'
  /** 契約済み */
  | 'ContractConcluded'
  /** 保険契約済み */
  | 'ContractConcludedInsurance'
  /** 証券契約済み */
  | 'ContractConcludedSecurities'
  /** 不満足の表明(OA向けに作ったものだが、一般にも使えるようなenumにする) */
  | 'GotComplaints'
  /** 後追い対応 */
  | 'Keeping'
  /** 失注 */
  | 'LostOrder'
  /** チャット対応中 */
  | 'Messaging'
  /** 未設定 */
  | 'NotDefined'
  /** 面談設定中 */
  | 'Offering'
  /** 初回面談実施待ち */
  | 'WaitingForFirstAppointment';

export type ConditionInput = {
  clickURLCondition?: SegmentConditionClickUrlConditionInput | null | undefined;
  enqueteAnsweredCondition?: SegmentConditionEnqueteAnsweredInput | null | undefined;
  inflowSourceCondition?: SegmentConditionInflowSourceInput | null | undefined;
  loginLinkCondition?: SegmentConditionLoginLinkInput | null | undefined;
  roomStatusCondition?: SegmentConditionRoomStatusInput | null | undefined;
  userVariableDefinitionCondition?: SegmentConditionUserVariableDefinitionInput | null | undefined;
};

export type CreateLineRichMenuInput = {
  lineRichMenu: LineRichMenuInput;
};

export type LineRichMenuActionType =
  | 'LINK'
  | 'TEXT';

export type LineRichMenuErrorReason =
  /** 同一セグメントの公開リッチメニューがすでに存在する */
  | 'DUPLICATE_SEGMENT_PUBLISHED'
  /** 上記の理由以外においてエラー */
  | 'UNKNOWN';

export type LineRichMenuInput = {
  backgroundImageFileName: string;
  chatBarText: string;
  isDisplayDefault: boolean;
  label: string;
  segment?: SegmentInput | null | undefined;
  status: LineRichMenuStatus;
  targetType: TargetType;
  template: string;
  templateActions: Array<LineRichMenuTemplateActionInput | null | undefined>;
};

export type LineRichMenuStatus =
  | 'PUBLISHED'
  | 'UNPUBLISHED';

export type LineRichMenuTemplateActionInput = {
  actionType: LineRichMenuActionType;
  label?: string | null | undefined;
  panelName: string;
  text?: string | null | undefined;
  url?: string | null | undefined;
};

export type SegmentConditionClickUrlConditionInput = {
  not: boolean;
  url: string;
};

export type SegmentConditionEnqueteAnsweredInput = {
  enqueteGUID: string;
  not: boolean;
};

export type SegmentConditionInflowSourceInput = {
  inflowSourceDefinitionGUID: string;
  not: boolean;
};

export type SegmentConditionLoginLinkInput = {
  not: boolean;
};

export type SegmentConditionRoomStatusInput = {
  not: boolean;
  status: ChatRoomStatus;
};

export type SegmentConditionUserVariableDefinitionInput = {
  definitionGUID: string | number;
  not: boolean;
  values: Array<string | number>;
};

export type SegmentInput = {
  conditions: Array<ConditionInput>;
};

export type TargetType =
  | 'ALL_FRIENDS'
  | 'ALL_MATCHED_USERS'
  | 'SEGMENT';

export type LineRichMenuNewPageQueryVariables = Exact<{ [key: string]: never; }>;


export type LineRichMenuNewPageQuery = { segmentConditionParameters: { enqueteAnsweredCondition: { enquetes: Array<{ guid: string, title: string }> }, inflowSourceCondition: { inflowSources: Array<{ guid: string, inflowSourceName: string }> }, clickURLCondition: { clickUrls: Array<{ guid: string, url: string }> }, userVariableDefinitionCondition: { userVariableDefinitions: Array<{ guid: string, name: string, value:
          | { __typename: 'UserVariableDefinitionValueMultipleSelect', options: Array<{ guid: string, name: string }> }
          | { __typename: 'UserVariableDefinitionValueSelect', options: Array<{ guid: string, name: string }> }
          | Record<PropertyKey, never>
         }> } } };

export type CreateLineRichMenuMutationVariables = Exact<{
  input: Types.CreateLineRichMenuInput;
}>;


export type CreateLineRichMenuMutation = { createLineRichMenu:
    | { __typename: 'CreateLineRichMenuSuccessPayload', lineRichMenu: { guid: string, label: string, status: Types.LineRichMenuStatus, templateName: string, backgroundImageFileName: string, chatBarText: string, isDisplayDefault: boolean, targetType: Types.TargetType, templateActions: Array<{ __typename: 'LineRichMenuTemplateAction', panelName: string, actionType: Types.LineRichMenuActionType, url: string | null, label: string | null, text: string | null }>, segment: { conditions: Array<
            | { __typename: 'SegmentConditionClickURLCondition' }
            | { __typename: 'SegmentConditionEnqueteAnswered' }
            | { __typename: 'SegmentConditionInflowSource' }
            | { __typename: 'SegmentConditionLoginLink' }
            | { __typename: 'SegmentConditionRoomStatus' }
          > } | null } }
    | { __typename: 'LineRichMenuErrorPayload', reason: Types.LineRichMenuErrorReason }
   };


export const LineRichMenuNewPageDocument = gql`
    query LineRichMenuNewPage {
  ...SegmentForm
}
    ${SegmentFormFragmentDoc}`;

/**
 * __useLineRichMenuNewPageQuery__
 *
 * To run a query within a Vue component, call `useLineRichMenuNewPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useLineRichMenuNewPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLineRichMenuNewPageQuery();
 */
export function useLineRichMenuNewPageQuery(options: VueApolloComposable.UseQueryOptions<LineRichMenuNewPageQuery, LineRichMenuNewPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LineRichMenuNewPageQuery, LineRichMenuNewPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LineRichMenuNewPageQuery, LineRichMenuNewPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<LineRichMenuNewPageQuery, LineRichMenuNewPageQueryVariables>(LineRichMenuNewPageDocument, {}, options);
}
export function useLineRichMenuNewPageLazyQuery(options: VueApolloComposable.UseQueryOptions<LineRichMenuNewPageQuery, LineRichMenuNewPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LineRichMenuNewPageQuery, LineRichMenuNewPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LineRichMenuNewPageQuery, LineRichMenuNewPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<LineRichMenuNewPageQuery, LineRichMenuNewPageQueryVariables>(LineRichMenuNewPageDocument, {}, options);
}
export type LineRichMenuNewPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<LineRichMenuNewPageQuery, LineRichMenuNewPageQueryVariables>;
export const CreateLineRichMenuDocument = gql`
    mutation CreateLineRichMenu($input: CreateLineRichMenuInput!) {
  createLineRichMenu(input: $input) {
    __typename
    ... on CreateLineRichMenuSuccessPayload {
      lineRichMenu {
        guid
        label
        status
        templateName
        backgroundImageFileName
        templateActions {
          __typename
          panelName
          actionType
          url
          label
          text
        }
        chatBarText
        isDisplayDefault
        targetType
        segment {
          conditions {
            __typename
          }
        }
      }
    }
    ... on LineRichMenuErrorPayload {
      reason
    }
  }
}
    `;

/**
 * __useCreateLineRichMenuMutation__
 *
 * To run a mutation, you first call `useCreateLineRichMenuMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateLineRichMenuMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateLineRichMenuMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateLineRichMenuMutation(options: VueApolloComposable.UseMutationOptions<CreateLineRichMenuMutation, CreateLineRichMenuMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateLineRichMenuMutation, CreateLineRichMenuMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateLineRichMenuMutation, CreateLineRichMenuMutationVariables>(CreateLineRichMenuDocument, options);
}
export type CreateLineRichMenuMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateLineRichMenuMutation, CreateLineRichMenuMutationVariables>;